import { render, staticRenderFns } from "./module-demo.vue?vue&type=template&id=d7acbe08&scoped=true"
import script from "./module-demo.vue?vue&type=script&lang=js"
export * from "./module-demo.vue?vue&type=script&lang=js"
import style0 from "./module-demo.vue?vue&type=style&index=0&id=d7acbe08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7acbe08",
  null
  
)

export default component.exports